(function () {
  'use strict';

  // Anzeige-Reihenfolge = Reihenfolge im Snippet (snippet-variant-specs-trautis).
  var SPEC_KEYS = ['lochkreis', 'lochanzahl', 'et_offset', 'felgenbreite_zoll', 'felgendurchmesser_zoll', 'zentrierung_mm'];

  // Rohwerte kommen als STRINGS aus dem Produkt-JSON ('' = fehlt) — so bleibt
  // "8.0" erhalten (eine JSON-Zahl würde zu JS 8 kollabieren → "8″" statt "8,0″")
  // und ET "0" ist truthy. Format-Kontrakt identisch zum Liquid-SSR in
  // snippet-variant-specs-trautis: Breite 8,0″ · Durchmesser 17″ · Zentrierung 72,6 mm.
  function formatSpecValue(key, raw) {
    if (raw === null || raw === undefined || raw === '') return null;
    var s = String(raw);
    if (key === 'felgenbreite_zoll') return s.replace('.', ',') + '″';
    if (key === 'felgendurchmesser_zoll') return s + '″';
    if (key === 'zentrierung_mm') return s.replace('.', ',') + ' mm';
    return s;
  }

  function resolveSpecs(variant) {
    var custom = variant && variant.metafields && variant.metafields.custom;
    var values = {};
    var hasAny = false;
    for (var i = 0; i < SPEC_KEYS.length; i++) {
      var key = SPEC_KEYS[i];
      var val = custom ? formatSpecValue(key, custom[key]) : null;
      values[key] = val;
      if (val !== null) hasAny = true;
    }
    return { values: values, hasAny: hasAny };
  }

  function getProductJSON(root) {
    var s = root.querySelector('script[type="application/json"][data-product-json]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function bindSpecs(root) {
    if (root.dataset.specsBound) return;
    var block = root.querySelector('[data-variant-specs]');
    if (!block) return;
    if (!getProductJSON(root)) return;
    root.dataset.specsBound = '1';
    root.addEventListener('trautis:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      var specs = resolveSpecs(v);
      if (!specs.hasAny) { block.setAttribute('hidden', ''); return; }
      block.removeAttribute('hidden');
      for (var i = 0; i < SPEC_KEYS.length; i++) {
        var key = SPEC_KEYS[i];
        var row = block.querySelector('[data-spec-row="' + key + '"]');
        if (!row) continue;
        var val = specs.values[key];
        if (val !== null) {
          var dd = row.querySelector('[data-spec-value]');
          if (dd) dd.textContent = val;
          row.removeAttribute('hidden');
        } else {
          row.setAttribute('hidden', '');
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(bindSpecs);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  // Exposed for test harness only; no runtime callers.
  window.TrautisVariantSpecs = { formatSpecValue: formatSpecValue, resolveSpecs: resolveSpecs };
})();

// Node.js / test harness export
if (typeof module !== 'undefined' && module.exports) {
  module.exports = (typeof window !== 'undefined' && window.TrautisVariantSpecs) || {
    formatSpecValue: function () { return null; },
    resolveSpecs: function () { return { values: {}, hasAny: false }; }
  };
}
